import type { ReactNode } from 'react'

/** Plain-English definitions of the four kinds of stock. */
export const NODE_TYPE_HELP: ReactNode = (
  <ul className='space-y-1.5'>
    <li>
      <span className='font-semibold'>Lever</span>: a dial a team sets directly.
      It moves only when a team decides to move it.
    </li>
    <li>
      <span className='font-semibold'>Level</span>: a condition, like readiness
      or trust, that settles where the pressure on it pulls it. Most stocks are
      Levels.
    </li>
    <li>
      <span className='font-semibold'>Accumulator</span>: something built up or
      drawn down over time, slowly and with momentum.
    </li>
    <li>
      <span className='font-semibold'>Drifter</span>: something nobody controls
      that moves on its own each round. Players can outpace it but not set it.
    </li>
  </ul>
)
